import { SidebarCategoryDTO } from '../../types/sidebar';
import SidebarModuleV2 from './SidebarModuleV2';

interface SidebarCategoryV2Props {
  categories: SidebarCategoryDTO[];
  sidebarExpanded: boolean;
  setSidebarExpanded: (expanded: boolean) => void;
  compactMode?: boolean;
}

/**
 * 📦 SidebarCategoryV2
 *
 * Renderiza la estructura completa de categorías y módulos.
 */
const SidebarCategoryV2: React.FC<SidebarCategoryV2Props> = ({
  categories,
  sidebarExpanded,
  setSidebarExpanded,
  compactMode = false,
}) => {
  // =====================================================
  // 🔹 Loading
  // =====================================================
  if (!categories.length) {
    return (
      <p className="text-gray-400 py-4 text-center text-sm">
        Cargando módulos...
      </p>
    );
  }

  // =====================================================
  // 🎨 Render
  // =====================================================
  return (
    <div className="no-scrollbar flex flex-col overflow-y-auto duration-300 ease-linear">
      <nav className={`pb-4 pt-2 ${sidebarExpanded ? 'px-4 lg:px-6' : 'px-2'}`}>
        {categories.map((category) => (
          <div key={category.code} className="mb-4">
            {/* 🔹 Categoría */}
            {sidebarExpanded && (
              <h3 className="mb-4 ml-4 text-sm font-semibold text-bodydark2">
                {category.name}
              </h3>
            )}

            {/* 🔹 Módulos */}
            <ul className="mb-6 flex flex-col gap-1.5">
              {category.modules.map((module) => (
                <li key={module.code}>
                  <SidebarModuleV2
                    module={module}
                    sidebarExpanded={sidebarExpanded}
                    setSidebarExpanded={setSidebarExpanded}
                    compactMode={compactMode}
                  />
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>
    </div>
  );
};

export default SidebarCategoryV2;
